
const RelationShipType = {
    FOLLOWING: 'following',
    FOLLOWER: 'follower',
    FRIEND: 'friend',
    BLOCKED: 'blocked',
    MUTUAL: 'mutual',
}

class Relationship {
    constructor({
        id = null,
        userId = null,
        relatedUserId = null,
        type = RelationShipType.FOLLOWING,
        isActive = true,
        createdAt = null,
        updatedAt = null,
    } = {}) {
        this.id = id;
        this.userId = userId;
        this.relatedUserId = relatedUserId;
        this.type = type;
        this.isActive = isActive;
        this.createdAt = createdAt ? new Date(createdAt) : new Date();
        this.updatedAt = updatedAt ? new Date(updatedAt) : new Date();
    }

    static fromAPI(data) {
        const mainData = {
            id: data.id,
            type: data.type,
            isActive: data.isActive,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
        };

        switch(data.type) {
            case 'following':
            case 'follower':
                mainData.userId = data.userId;
                mainData.relatedUserId = data.relatedUserId;
                break;
            case 'blocked':
                mainData.userId = data.blockerId;
                mainData.relatedUserId = data.blockedId;
                break;
            case 'mute':
                mainData.userId = data.muterId;
                mainData.relatedUserId = data.mutedId;
                break;
        }

        return new Relationship(mainData);
    }

    toJSON() {
        return {
            id: this.id,
            type: this.type,
            isActive: this.isActive,
            createdAt: this.createdAt?.toISOString() || null,
            updatedAt: this.updatedAt?.toISOString() || null,
        };
    }
}